module.exports = __webpack_public_path__ + "assets/img/five_star_large.816affa0.svg";